import { useQuery } from '@tanstack/react-query'
import checkUserSession from '../utils/checkUserSession'

const useSessionChecker = () => {
  const { data, error, isLoading, refetch } = useQuery({
    queryKey: ['sessionChecker'],
    queryFn: async () => {
      const session = await checkUserSession()
      return session
    },
    staleTime: 0,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  })
  return { data, error, loading: isLoading, refetch }
}

export default useSessionChecker
